import React, { useState } from "react";

const TabGroup = ({ tabs }) => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div className="w-full flex flex-wrap">
      <div className="flex flex-wrap border-subText gap-2 mb-2">
        {tabs.map((tab, index) => (
          <button
            role="tab"
            key={index}
            onClick={() => setActiveTab(index)}
            aria-selected={activeTab === index ? "true" : "false"}
            className={`p-3
              text-primary-dark
              border-1
              rounded-xl text-sm font-medium transition
              ${
                activeTab === index
                  ? "border-none text-primary-normal bg-primary-dark"
                  : "text-primary-dark hover:text-primary-title"
              }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="w-full">
        {tabs[activeTab] && <div>{tabs[activeTab].content}</div>}
      </div>
    </div>
  );
};

export default TabGroup;
